// test1685
(1685 && 0);
